import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea sept">
                                            <div className="circle_title-first"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>HOW RISKY ARE YOU?
                                            </div>

                                            <div className="border_subtitle">Develop an understanding of your
                                                personality style...
                                            </div>
                                            <p>One way to understand how ‘risky’ you really are, or are likely
                                                to be, is to complete a personality
                                                questionnaire and get some feedback on the outcome. The most
                                                useful questionnaires are based
                                                on the Five Factor Model of Personality and all include
                                                assessment of risk-taking tendencies.</p>
                                            <p>In the situations<a className="superscripttext"
                                                                   href="further_info.php?course=300"><sup>4</sup></a> described
                                                below, imagine you‘re helping someone make a decision. Indicate
                                                the
                                                minimum odds you‘d need to recommend one of the available
                                                options.</p>


                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport tablesrink task_active2">
                                                <tbody>
                                                <tr>
                                                    <th width="100%" align="left" valign="top"
                                                        className="green_curve green_curve1"
                                                        colSpan="2">Increase your self-awareness: are you a risk
                                                        taker?
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="100%">

                                                        <span className="table_inner_cont">1</span><p
                                                        className="table_inner_cont_p"
                                                        style={{paddingBottom:'5px !important'}}>Mr. B, a
                                                        45-year-old accountant, has recently been told by his
                                                        doctor that he has a heart condition. It‘s
                                                        serious enough to force him to make several fundamental
                                                        changes to his lifestyle including reducing
                                                        his work load, drastically changing his diet and giving
                                                        up favourite leisure pursuits. The doctor
                                                        suggests a delicate operation which, if successful,
                                                        would cure the condition. However, its success
                                                        can‘t be guaranteed, and it may prove fatal. Listed
                                                        below are probabilities or odds of the operation
                                                        being successful. Indicate the lowest probability you‘d
                                                        consider acceptable for recommending it.</p>

                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="100%">

                                                        <input type="checkbox"
                                                               name="IncreaseYourSelfAwareness"
                                                               id="IncreaseYourSelfAwareness1"
                                                               value="1"
                                                               onChange={this.props.handleChangePageData}
                                                               checked={this.props.pageData?.IncreaseYourSelfAwareness === 1}/>
                                                        <label className="cursor-pointer" htmlFor="IncreaseYourSelfAwareness1">&nbsp;</label>

                                                        Tick here if you think that Mr. B should not have
                                                        the operation, no matter what the probabilities are
                                                        (10 in 10).<p className="pad-septar"></p>


                                                        <input type="checkbox"
                                                               name="IncreaseYourSelfAwareness"
                                                               id="IncreaseYourSelfAwareness2"
                                                               value="2"
                                                               onChange={this.props.handleChangePageData}
                                                               checked={this.props.pageData?.IncreaseYourSelfAwareness === 2}/>
                                                        <label className="cursor-pointer" htmlFor="IncreaseYourSelfAwareness2">&nbsp;</label>

                                                        The chances are 9 in 10 that the operation will
                                                        be a success.<p className="pad-septar"></p>


                                                        <input type="checkbox"
                                                               name="IncreaseYourSelfAwareness"
                                                               id="IncreaseYourSelfAwareness3"
                                                               value="3"
                                                               onChange={this.props.handleChangePageData}
                                                               checked={this.props.pageData?.IncreaseYourSelfAwareness === 3}/>
                                                        <label className="cursor-pointer" htmlFor="IncreaseYourSelfAwareness3">&nbsp;</label>

                                                        The chances are 7 in 10 that the operation
                                                        will be a success.<p
                                                        className="pad-septar"></p>

                                                        <input type="checkbox"
                                                               name="IncreaseYourSelfAwareness"
                                                               id="IncreaseYourSelfAwareness4"
                                                               value="4"
                                                               onChange={this.props.handleChangePageData}
                                                               checked={this.props.pageData?.IncreaseYourSelfAwareness === 4}/>
                                                        <label className="cursor-pointer" htmlFor="IncreaseYourSelfAwareness4">&nbsp;</label>

                                                        The chances are 5 in 10 that the
                                                        operation will be a success.<p
                                                        className="pad-septar"></p>

                                                        <input type="checkbox"
                                                               name="IncreaseYourSelfAwareness"
                                                               id="IncreaseYourSelfAwareness5"
                                                               value="5"
                                                               onChange={this.props.handleChangePageData}
                                                               checked={this.props.pageData?.IncreaseYourSelfAwareness === 5}/>
                                                        <label className="cursor-pointer" htmlFor="IncreaseYourSelfAwareness5">&nbsp;</label>

                                                        The chances are 3 in 10 that the
                                                        operation will be a success.<p
                                                        className="pad-septar"></p>

                                                        <input type="checkbox"
                                                               name="IncreaseYourSelfAwareness"
                                                               id="IncreaseYourSelfAwareness6"
                                                               value="6"
                                                               onChange={this.props.handleChangePageData}
                                                               checked={this.props.pageData?.IncreaseYourSelfAwareness === 6}/>
                                                        <label className="cursor-pointer" htmlFor="IncreaseYourSelfAwareness6">&nbsp;</label>

                                                        The chances are 1 in 10 that the
                                                        operation will be a success.<p
                                                        className="pad-septar"></p>


                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>


                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport tablesrink task_active2">
                                                <tbody>
                                                <tr>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="100%">
                                                        <span className="table_inner_cont">2</span><p
                                                        className="table_inner_cont_p"
                                                        style={{paddingBottom:'5px !important'}}>Mr. D is captain
                                                        of University X‘s sports team. University X is playing
                                                        its traditional rival, University Y,
                                                        in the final game of the season. The game is in its
                                                        final seconds, and University X is losing.
                                                        University X has time for one more play. Mr. D, the
                                                        captain, must decide whether it would be best
                                                        to settle for a score to tie the match that would almost
                                                        certainly work or, on the other hand, try a
                                                        more complicated and risky play that would bring victory
                                                        if successful but defeat if not. Tick the
                                                        lowest probability you‘d consider acceptable for the
                                                        risky play to be attempted.</p><p>

                                                    </p></td>
                                                </tr>
                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="100%">

                                                        <input type="checkbox"
                                                               name="MrDIsCaptainOfUniversityXsSportsTeam"
                                                               id="MrDIsCaptainOfUniversityXsSportsTeam1"
                                                               value="1"
                                                               onChange={this.props.handleChangePageData}
                                                               checked={this.props.pageData?.MrDIsCaptainOfUniversityXsSportsTeam === 1}/>
                                                        <label className="cursor-pointer" htmlFor="MrDIsCaptainOfUniversityXsSportsTeam1">&nbsp;</label>

                                                        Tick here if you think that Mr. D should not attempt
                                                        the risky play, no matter what the probabilities 10
                                                        in 10.<p className="pad-septar"></p>

                                                        <input type="checkbox"
                                                               name="MrDIsCaptainOfUniversityXsSportsTeam"
                                                               id="MrDIsCaptainOfUniversityXsSportsTeam2"
                                                               value="2"
                                                               onChange={this.props.handleChangePageData}
                                                               checked={this.props.pageData?.MrDIsCaptainOfUniversityXsSportsTeam === 2}/>
                                                        <label className="cursor-pointer" htmlFor="MrDIsCaptainOfUniversityXsSportsTeam2">&nbsp;</label>

                                                        The chances are 9 in 10 that the risky play will
                                                        work.<p className="pad-septar"></p>

                                                        <input type="checkbox"
                                                               name="MrDIsCaptainOfUniversityXsSportsTeam"
                                                               id="MrDIsCaptainOfUniversityXsSportsTeam3"
                                                               value="3"
                                                               onChange={this.props.handleChangePageData}
                                                               checked={this.props.pageData?.MrDIsCaptainOfUniversityXsSportsTeam === 3}/>
                                                        <label className="cursor-pointer" htmlFor="MrDIsCaptainOfUniversityXsSportsTeam3">&nbsp;</label>

                                                        The chances are 7 in 10 that the risky play
                                                        will work.<p className="pad-septar"></p>

                                                        <input type="checkbox"
                                                               name="MrDIsCaptainOfUniversityXsSportsTeam"
                                                               id="MrDIsCaptainOfUniversityXsSportsTeam4"
                                                               value="4"
                                                               onChange={this.props.handleChangePageData}
                                                               checked={this.props.pageData?.MrDIsCaptainOfUniversityXsSportsTeam === 4}/>
                                                        <label className="cursor-pointer" htmlFor="MrDIsCaptainOfUniversityXsSportsTeam4">&nbsp;</label>

                                                        The chances are 5 in 10 that the risky
                                                        play will work.<p
                                                        className="pad-septar"></p>

                                                        <input type="checkbox"
                                                               name="MrDIsCaptainOfUniversityXsSportsTeam"
                                                               id="MrDIsCaptainOfUniversityXsSportsTeam5"
                                                               value="5"
                                                               onChange={this.props.handleChangePageData}
                                                               checked={this.props.pageData?.MrDIsCaptainOfUniversityXsSportsTeam === 5}/>
                                                        <label className="cursor-pointer" htmlFor="MrDIsCaptainOfUniversityXsSportsTeam5">&nbsp;</label>

                                                        The chances are 3 in 10 that the
                                                        risky play will work.<p
                                                        className="pad-septar"></p>

                                                        <input type="checkbox"
                                                               name="MrDIsCaptainOfUniversityXsSportsTeam"
                                                               id="MrDIsCaptainOfUniversityXsSportsTeam6"
                                                               value="6"
                                                               onChange={this.props.handleChangePageData}
                                                               checked={this.props.pageData?.MrDIsCaptainOfUniversityXsSportsTeam === 6}/>
                                                        <label className="cursor-pointer" htmlFor="MrDIsCaptainOfUniversityXsSportsTeam6">&nbsp;</label>

                                                        The chances are 1 in 10 that the
                                                        risky play will work.<p
                                                        className="pad-septar"></p>


                                                    </td>
                                                </tr>


                                                </tbody>
                                            </table>


                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport tablesrink task_active2">
                                                <tbody>
                                                <tr>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="100%">
                                                        <span className="table_inner_cont">3</span><p
                                                        className="table_inner_cont_p"
                                                        style={{paddingBottom:'5px !important'}}>Ms. K is a
                                                        successful businesswoman who has done a lot of valuable
                                                        work for the community.
                                                        She has been approached by the leaders of her local
                                                        school as a possible councillor in the next
                                                        election. Ms. K would like to become a school councillor
                                                        but to do so would involve a serious
                                                        investment because of the time she needs to campaign to
                                                        the parents who will vote in the elections.
                                                        She would also have to spend less time with her family
                                                        and with her other charities. Tick the lowest
                                                        probability you‘d consider worthwhile for Ms. K to run
                                                        for political office.</p>

                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="100%">

                                                        <input type="checkbox"
                                                               name="MsKIsASuccessfulBusinesswoman"
                                                               id="MsKIsASuccessfulBusinesswoman1"
                                                               value="1"
                                                               onChange={this.props.handleChangePageData}
                                                               checked={this.props.pageData?.MsKIsASuccessfulBusinesswoman === 1}/>
                                                        <label className="cursor-pointer" htmlFor="MsKIsASuccessfulBusinesswoman1">&nbsp;</label>

                                                        Tick here if you think that Ms. K should not run for
                                                        political office, no matter what the probability 10
                                                        in 10.<p className="pad-septar"></p>

                                                        <input type="checkbox"
                                                               name="MsKIsASuccessfulBusinesswoman"
                                                               id="MsKIsASuccessfulBusinesswoman2"
                                                               value="2"
                                                               onChange={this.props.handleChangePageData}
                                                               checked={this.props.pageData?.MsKIsASuccessfulBusinesswoman === 2}/>
                                                        <label className="cursor-pointer" htmlFor="MsKIsASuccessfulBusinesswoman2">&nbsp;</label>

                                                        The chances are 9 in 10 that Ms. K will win the
                                                        election.<p className="pad-septar"></p>

                                                        <input type="checkbox"
                                                               name="MsKIsASuccessfulBusinesswoman"
                                                               id="MsKIsASuccessfulBusinesswoman3"
                                                               value="3"
                                                               onChange={this.props.handleChangePageData}
                                                               checked={this.props.pageData?.MsKIsASuccessfulBusinesswoman === 3}/>
                                                        <label className="cursor-pointer" htmlFor="MsKIsASuccessfulBusinesswoman3">&nbsp;</label>

                                                        The chances are 7 in 10 that Ms. K will win
                                                        the election.<p className="pad-septar"></p>

                                                        <input type="checkbox"
                                                               name="MsKIsASuccessfulBusinesswoman"
                                                               id="MsKIsASuccessfulBusinesswoman4"
                                                               value="4"
                                                               onChange={this.props.handleChangePageData}
                                                               checked={this.props.pageData?.MsKIsASuccessfulBusinesswoman === 4}/>
                                                        <label className="cursor-pointer" htmlFor="MsKIsASuccessfulBusinesswoman4">&nbsp;</label>

                                                        The chances are 5 in 10 that Ms. K will
                                                        win the election.<p
                                                        className="pad-septar"></p>

                                                        <input type="checkbox"
                                                               name="MsKIsASuccessfulBusinesswoman"
                                                               id="MsKIsASuccessfulBusinesswoman5"
                                                               value="5"
                                                               onChange={this.props.handleChangePageData}
                                                               checked={this.props.pageData?.MsKIsASuccessfulBusinesswoman === 5}/>
                                                        <label className="cursor-pointer" htmlFor="MsKIsASuccessfulBusinesswoman5">&nbsp;</label>

                                                        The chances are 3 in 10 that Ms. K
                                                        will win the election.<p
                                                        className="pad-septar"></p>

                                                        <input type="checkbox"
                                                               name="MsKIsASuccessfulBusinesswoman"
                                                               id="MsKIsASuccessfulBusinesswoman6"
                                                               value="6"
                                                               onChange={this.props.handleChangePageData}
                                                               checked={this.props.pageData?.MsKIsASuccessfulBusinesswoman === 6}/>
                                                        <label className="cursor-pointer" htmlFor="MsKIsASuccessfulBusinesswoman6">&nbsp;</label>

                                                        The chances are 1 in 10 that Ms.
                                                        K will win the election.<p
                                                        className="pad-septar"></p>


                                                    </td>
                                                </tr>


                                                </tbody>
                                            </table>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.savePageData('Page4')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>

                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    }
}